function ctrl($scope, Global, timeFormat, fetchStream, $stateParams, socketIo, settings, usSpinnerService) {
    let model = this;
    $scope.global = Global;
    model.settings = settings;

    model.lineChartIdentifiers = { key: false, id: false };
    model.rowChartIdentifiers = { key: false, id: false };
    model.geoChartIdentifiers = { key: false, id: false };
    model.sevLevIdentifiers = { key: false, id: false };
    model.tableIdentifiers =
        { key: false, id: false };

    socketIo('/api/hybrid_alerts/ueba_details').then(function (socket) {

        /////////////
        /// TABLE ///
        /////////////
        // register data object
        $scope.main.registerVisual({
            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
            searchable: true, // optional search param.. no if undefined
            get: {
                call: 'table',
                socket: socket
            },
            grouping: ['id'],
            sort: { direction: "-", col: "time" }, // "-"=desc, "+"=asc
            title: 'UEBA Details',
            columns: [
                { title: 'Date', select: 'time', dView: true },
                { title: 'IPv4', select: 'ipv4', dView: true },
                { title: 'MAC Address', select: 'mac', dView: true },
                { title: 'Hostname', select: 'hostname', dView: true },
                { title: 'OS name', select: 'os_name', dView: false },
                { title: 'OS version', select: 'os_version', dView: false },
                { title: 'OS build', select: 'os_build', dView: false },
                { title: 'Platform', select: 'platform', dView: false },
                { title: 'MITRE name', select: 'mitre_name', dView: true },
                { title: 'MITRE technique', select: 'mitre_tech', dView: true },
                { title: 'MITRE subtechnique', select: 'mitre_subtech', dView: true },
                { title: 'MITRE tactic', select: 'mitre_tactic', dView: true },
                { title: 'MITRE info', select: 'mitre_info', dView: true },
                { title: 'events', select: 'events', dView: false },
            ],
            searchCategories: {
            }
        })
        // fetch the data when the object is registered
        .then(function (result) {
            model.tableIdentifiers = {
                id: result.id,
                key: result.key
            }
            // initalize table with column information so it can compile the directive
            $scope.$broadcast('table-build', model.tableIdentifiers);
            let time = angular.copy($scope.main.getTime());
            model.loadStart = time.end
            model.loadEnd = time.end
            // return promise to build dimensions and groups for table
            return new fetchStream(result.settings.get.call, result.settings.get.socket);
        })
        .then(function (result) {
            model.complete = true;
            // stop the table spinner as soon as the resolve comes in
            usSpinnerService.stop(model.tableIdentifiers.id);
        }, function (err) {
            console.log('table error', err);

        }, function (result) {
            console.log('table result', result.rows)
            // add rows
            console.log($scope.main.dataObjects[model.tableIdentifiers.key])
            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                // with our first data return, we can build dimensions and groups for our data
                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
                    // dont start the spinner if the table loads faster than building group dim
                    if (!model.complete) {
                        // start table spinner right before init, but after build
                        usSpinnerService.spin(model.tableIdentifiers.id);
                    }
                    // initalize rows
                    $scope.$broadcast('init', model.tableIdentifiers);
                    if (result.min) {
                        model.loadStart = result.min;
                    }
                }, function (err) {
                    console.log('error', err);
                })
            } else {
                if (result.min) {
                    model.loadStart = result.min;
                }
                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
            }
        })
        $scope.$on('$destroy', function () {
            socket.disconnect();
        });
    })
};

ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', '$stateParams', 'socketIo', 'settings', 'usSpinnerService'];
module.exports = ctrl;






/** WEBPACK FOOTER **
 ** ./src/pages/controllers/hybrid_alerts/ueba_details.ts
 **/